import { OptionSelectors } from '../qf/OptionSelectors';

export class ClientOptionSelectors extends OptionSelectors {
    constructor(input_type, target_elements) {
        super(input_type, target_elements);

        this.range_slide_selector = '[range-slider]';

        this.init();
    }

    init() {
        // super.init();
        // this.changeThumbPosition(this.getRangeSliders(document));
        document.body.addEventListener('input', this.handleRangeChange.bind(this));
        // set a document body listener for mouseup event
        document.body.addEventListener('mouseup', this.handleMouseUp.bind(this));
        // set a document body listener for touchend event
        document.body.addEventListener('touchend', this.handleMouseUp.bind(this));

    }




    // listen for mouseup event on range sliders
    handleMouseUp(e) {
        if (e.target.closest(this.range_slide_selector)) {
            // set timeout to allow the slider to update its value
            setTimeout(() => {
                const closest_product_section = e.target.closest('[product-section]');
                const selectElement = this.getSelectElement(closest_product_section);
                if (selectElement) {
                    const event = new Event('change');
                    selectElement.dispatchEvent(event);
                    this.handleRangeChange(event);
                    // this.changeThumbPosition(sliders,false);
                    // this.debounceUpdateProduct(selectElement);
                }
            }, 500);
            return;
        }
    }

    handleRangeChange(e) {
        super.handleChange(e);
        if (e.target.closest(this.range_slide_selector)) {
            const closest_product_section = e.target.closest('[product-section]');
            const sliders = this.getRangeSliders(closest_product_section);
            if (sliders.length == 0) {
                // console.log("No sliders found");
                return;
            }
            this.changeThumbPosition(e.target);
        }
    }

    getSelectElement(html) {
        const select_element = html.querySelector('select');
        if (!select_element) {
            return;
        }
        // if select has the attribute detailed-select
        if (select_element.hasAttribute('detailed-select')) {
            return select_element;
        }
    }

    changeSelectElement(select, slider) {
        const selectElement = select;
        const optionIndex = parseInt(slider.value);

        if (selectElement) {
            selectElement.selectedIndex = optionIndex - 1;
            // fire change event on select element
            const event = new Event('change', { bubbles: true });
            selectElement.dispatchEvent(event);
        }
    }

    getRangeSliders(html) {
        const range_slider_selector = html.querySelectorAll(this.range_slide_selector);
        return range_slider_selector;
    }

    changeThumbPosition(slider) {
        if (!slider) {
            return;
        }
        const thumbOverlay = slider.nextElementSibling.querySelector('.thumb-overlay');
        // const thumbOverlay = slider.closest(".option-range").querySelector('.thumb-overlay');
        const step_tracker = slider.nextElementSibling.nextElementSibling;
        const sliderRect = slider.nextElementSibling.getBoundingClientRect();
        const thumbWidth = 28; // Must match CSS thumb size
        const min = slider.min;
        const max = slider.max;
        const value = slider.value;

        // Calculate the thumb position
        const percent = (value - min) / (max - min);
        const thumbX = percent * (sliderRect.width - thumbWidth);

        // Apply linear gradient based on percent to range slider -webkit-slider-runnable-track
        step_tracker.style.background = `linear-gradient(to right, var(--primary-color) ${percent * 100}%, #DBDBDB ${percent * 100}%)`;

        // Update the overlay position and text
        thumbOverlay.style.left = `${thumbX + thumbWidth / 2}px`;
        thumbOverlay.textContent = value;
        thumbOverlay.classList.remove('highlight');
        const steps = step_tracker.querySelectorAll('.step');
        steps.forEach(step => {
            step.classList.remove('highlight');
            step.style.background = '#DBDBDB';
            if (value == 4 || value == 8 || value == 12 ) {
                step_tracker.querySelector(`.step:nth-child(${value})`).classList.add('highlight');
                thumbOverlay.classList.add('highlight');
            }
        });

        const current_steps = step_tracker.querySelectorAll(`.step:nth-child(-n+${value})`);
        current_steps.forEach(step => {
            step.style.background = 'var(--primary-color)';
        });

        // get slider closest [option] element
        const option = slider.closest(this.Option);

        this.changeSelectElement(this.getSelectElement(option), slider);
    }
}

// Override the global ProductFormVariantSelect reference with the extended class
window.OptionSelectors = ClientOptionSelectors;